export enum SubscriptionPlanModuleId {
  chat = "Jugl::Chat",
  calls = "Jugl::Calls",
  people = "Jugl::People",
  timeLog = "Jugl::TimeLog",
  drive = "Jugl::Drive",
  clients = "Jugl::Clients",
  taskSharing = "Jugl::Task::Sharing",
  workato = "Jugl::Workato",
  task = "Jugl::Task",
  orderForm = "Jugl::OrderForm",
  inventory = "Jugl::Inventory",
  whatsappCrm = "Jugl::WhatsappCrm",
  travelLog = "Jugl::TravelLog",
  dashboard = "Jugl::Dashboard",
  integration = "Jugl::Integration",
  invoices = "Jugl::Invoice",
  aiAgents = "Jugl::AI_Agents",
  automation = "Jugl::Automation",
}
